import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

interface Props {
  amount: number;
  color?: string;
  onClick: () => void;
}

const CircularIconButton: React.FC<React.PropsWithChildren<Props>> = ({
  amount,
  color,
  children,
  onClick,
  ...otherProps
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.width = wrapperRef.current.style.height;
    }
  }, []);

  return (
    <Wrapper color={color} ref={wrapperRef} onClick={onClick} {...otherProps}>
      <AmountBadge>{amount}</AmountBadge>
      <Children>{children}</Children>
    </Wrapper>
  );
};

const AmountBadge = styled.div`
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 9999px;

  position: absolute;
  top: 0;
  right: 0;
  transform: translate(25%, -25%);
  font-size: 1.4rem;

  color: white;
  background-color: ${({ theme }) => theme.primary[500]};
`;

const Wrapper = styled.div<{ color?: string }>`
  position: relative;
`;

const Children = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${({ color }) => (color ? color : '#F0F1F3')};
  border-radius: 9999px;
  width: 4.4rem;
  height: 4.4rem;

  /* Fix very small icon offset */
  > svg {
    margin-right: -2px;
  }

  transition: opacity 0.2s;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`;

export default CircularIconButton;
